export const formatDate = (date, notHours = false) => {
  if (!date) return "";

  const options = {
    month: "numeric",
    day: "numeric",
    hour: notHours ? undefined : "numeric",
    minute: notHours ? undefined : "numeric",
    second: notHours ? undefined : "numeric",
  };
  return new Intl.DateTimeFormat("pt-BR", options).format(new Date(date));
};
